import { BannerPreview } from '../../../announcements/BannerPreview';
import type { AnnouncementBanner as AnnouncementBannerType } from '../../../../types/announcements';

export const AnnouncementBanner = ({
  banner,
}: {
  banner: AnnouncementBannerType;
}) => {
  return (
    <div className="mt-2">
      <BannerPreview banner={banner} />
    </div>
  );
};
